import { AboveGradeWallType, BelowGradeWallType } from 'data/types';

type WallType = AboveGradeWallType | BelowGradeWallType;

function stripUnpersistedFields(wall: WallType): Record<string, unknown> {
  const { edge, ...rest } = wall as AboveGradeWallType;
  return rest;
}

export function wallsContentEqual(a: WallType[], b: WallType[]): boolean {
  if (a.length !== b.length) return false;
  return a.every(
    (wall, index) =>
      JSON.stringify(stripUnpersistedFields(wall)) ===
      JSON.stringify(stripUnpersistedFields(b[index]))
  );
}
